// export const API_URL = 'http://13.233.237.65/api/';
// export const API_URL = 'http://localhost:8000/api/';
export const API_URL = 'https://api.angelcapital.in/api/';
